import { Button, Card, CardContent, CardHeader, Badge } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { CUSTOM_INTEGRATIONS } from "./constants";
import CustomIntegrationForm from "./CustomIntegrationForm";
import { AddIcon } from "@/assets/icons";
import { CommonIntegrationInstance } from "./mcpSlice";
import { FC, useState } from "react";

interface EditingIntegration {
  instance: CommonIntegrationInstance;
  template: (typeof CUSTOM_INTEGRATIONS)[0];
}

interface AvailableCustomIntegrationsProps {
  onAddClick?: (integration: (typeof CUSTOM_INTEGRATIONS)[0]) => void;
}

const AvailableCustomIntegrations: FC<AvailableCustomIntegrationsProps> = ({ onAddClick }) => {
  const [selectedIntegration, setSelectedIntegration] = useState<
    (typeof CUSTOM_INTEGRATIONS)[0] | null
  >(null);
  const [editingIntegration, setEditingIntegration] = useState<EditingIntegration | null>(null);

  const handleAddClick = (integration: (typeof CUSTOM_INTEGRATIONS)[0]) => {
    if (onAddClick) {
      onAddClick(integration);
    } else {
      setSelectedIntegration(integration);
      setEditingIntegration(null);
    }
  };

  const handleFormClose = () => {
    setSelectedIntegration(null);
    setEditingIntegration(null);
  };
  return (
    <Stack direction="column" className="al-gap-6">
      <Stack direction="row" wrap className="al-gap-4">
        {CUSTOM_INTEGRATIONS.map(integration => (
          <div
            key={integration.name}
            className="al-transform al-transition-transform al-duration-100 hover:al-scale-[1.02] active:al-scale-[0.98]"
          >
            <Card className="al-w-[300px] al-transition-all al-duration-200 al-bg-card">
              <CardHeader className="al-p-4 al-pb-2">
                <Stack direction="column" className="al-gap-1">
                  <Stack direction="row" className="al-justify-between al-items-center">
                    <span className="al-font-medium">{integration.name}</span>
                    <Badge variant="outline" className="al-w-fit al-h-5">
                      {integration.type}
                    </Badge>
                  </Stack>
                  {integration.comingSoon && (
                    <Badge variant="outline" className="al-w-fit al-h-5">
                      Coming Soon
                    </Badge>
                  )}
                </Stack>
              </CardHeader>
              <CardContent className="al-p-4">
                <Stack direction="column" className="al-gap-3">
                  {/* Description */}
                  {integration.description && (
                    <p className="al-text-sm al-text-muted-foreground">{integration.description}</p>
                  )}

                  {/* Add button */}
                  <Button
                    variant="outline"
                    className="al-w-full"
                    onClick={() => handleAddClick(integration)}
                    disabled={integration.comingSoon}
                  >
                    <AddIcon className="al-mr-2 al-h-4 al-w-4" />
                    {`Create ${integration.type} integration`}
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </div>
        ))}
      </Stack>
      {!onAddClick && (selectedIntegration || editingIntegration) && (
        <CustomIntegrationForm
          integration={editingIntegration?.template || selectedIntegration!}
          initialConfig={editingIntegration?.instance}
          onClose={handleFormClose}
        />
      )}
    </Stack>
  );
};

export default AvailableCustomIntegrations;
